// 地图
import Map3D from './Map3D';
export default class MapWapper {
    // 二维地图
    private map: any = null;

    // 二维地图
    private map2d: any = null;
    // 三维地球
    private global: any = null;

    private comp3d: any = null;
    // 参数
    private options: any = null;
    // 状态
    private state: number = -1;
    // 通用基础工具
    private components: any = {};
    private currentD: string;
    /**
     * @param opts {object}
     * @param opts.targetId string
     * @param opts.mapConfig
     * @param opts.symbolConfig
     */
    constructor(opts: any) {
        //
        this.options = opts || {};
        // todo 根据二三维切换
        this.map2d = new G.Map(this.options.mapConfig.map);
        if (this.options.globeId) {
            this.comp3d = new Map3D({
                mapId: this.options.globeId,
                mapConfig: this.options.mapConfig,
                symbolConfig: this.options.symbolConfig,
                serviceConfig: this.options.serviceConfig,
            });
        }

    }

    /**
     * 设置参数
     * @param opts
     */
    public setOptions(opts: any) {
        if (opts) {
            for (const key of Object.keys(opts)) {
                this.options[key] = opts[key];
            }
        }
    }

    public getOptions() {
        return this.options;
    }

    /**
     * 初始化
     */
    public init() {
        this.initMap();
        this.initBaseLayers();
        this.initServerLayers();
        this.switchDimension('2d');
        this.currentD = '2d';
        this.initControls();
        // 初始加载三维球
        if (this.options.globeId) {
            this.global = this.comp3d.load();
        }
        this.state = 1;
    }

    /**
     * 同步二三维地图视野
     * @param map 当前地图
     * @param targetmap 目标地图
     */
    public syncronizeView(map: any, targetmap: any) {
        if (this.map2d && this.global) {
            const ext = map.getExtent();
            if (map.camera) {
                targetmap.pan(ext);
            } else {
                targetmap.camera.setView(ext);
            }
        }
    }
    /**
     * 切换二三维
     * @param d {String} 2d/3d
     */
    public switchDimension(d: string) {
        switch (d) {
            case '2d':
                this.map = this.map2d;
                if (this.currentD !== d) {
                    this.syncronizeView(this.global, this.map2d);
                    this.currentD = d;
                }
                break;
            case '3d':
                if (!this.global) {
                    this.global = this.comp3d.load();
                }
                this.map = this.global;
                if (this.currentD !== d) {
                    this.syncronizeView(this.map2d, this.global);
                    this.currentD = d;
                }

                break;
        }
    }

    public setBaseLayer(item: any) {
        switch (item.dimension) {
            case '2d':
                this.switchLayer(item);
                break;
            case '3d':
                this.comp3d.setBaseLayer(item);
        }

    }

    public switchLayer(item: any) {
        const resthttp = new g2.core.RestHttp({
            client_id: this.options.serviceConfig.egis.clientId,
            client_secret: this.options.serviceConfig.egis.clientSecret,
        });
        const originLayers = item.layers;
        if (Array.isArray(originLayers)) {
            originLayers.forEach((item, index) => {
                if (item.glStyle) {
                    // 矢量切片增加http参数
                    item.http = resthttp;
                }
            });
        }
        G.utils.LayerUtil.switchBaseLayer({
            map: this.map2d,
            layerOpts: item,
            // restHttp: resthttp,
        });
    }

    /**
     * 初始化地图
     */
    public initMap(): void {
        this.map2d.init({
            targetId: this.options.targetId.split(',')[0],
        });
    }
    /**
     * 初始化底图
     */
    public initBaseLayers() {
        const baseLayers = this.options.mapConfig.baseLayers;
        const serviceConfig = this.options.serviceConfig;
        let resthttp: any = null;
        // if (serviceConfig && serviceConfig.egis) {
        //     const clientId = serviceConfig.egis.clientId;
        //     const clientSecret = serviceConfig.egis.clientSecret;
        //     resthttp = new g2.core.RestHttp({
        //         client_id: clientId,
        //         client_secret: clientSecret,
        //     });
        // }
        const conf = baseLayers[0];
        // const baseLayer = G.utils.LayerUtil.createBaseLayer(conf, resthttp);
        const baseLayer = G.utils.LayerUtil.createBaseLayer(conf);
        this.map2d.addLayer(baseLayer);
        G.g2map = baseLayer.map;
        console.log(baseLayer);
        // 初始化点线面图层组
        this.map2d.initialGroupLayers();
    }
    /**
     * 初始化服务底图
     */
    public initServerLayers() {
        const baseLayers = this.options.mapConfig.baseLayers;
        const conf = baseLayers[1].layers;
        conf.forEach((item: any) => {
            const superWMTS = new egis.carto.TileLayer(item);
            this.map2d.addLayer(superWMTS);
        });
    }

    /**
     * 初始化控件
     */
    public initControls() {
        this.getMap().addScaleLineControl();
    }

    public getMap() {
        return this.map2d;
    }

    public getMap3D() {
        return this.global;
    }

    // 是否初始化
    public initialized() {
        return this.state >= 0;
    }

    /**
     * 通用全局工具
     */
    public initComponents() {
        const popupManager: any = new G.common.PopupManager({
            map: this.getMap(),
            autoPanTimeout: 500,
            // 默认层级
            zIndex: 9,
            // 像素偏移量
            offset: [0, -30],
        });
        popupManager.load();
        // 要素定位
        const featureLocate: any = new G.common.FeatureLocate({
            map: this.getMap(),
            padding: new Array(4).fill(100),
            maxZoom: 16,
            duration: {
                move: 300,
                zoom: 500,
            },
        });
        featureLocate.load();
        // 要素高亮
        const featureHighlight: any = new G.common.FeatureHighlight({
            id: 'featureHighlight',
            name: 'featureHighlight',
            map: this.getMap(),
            blink: {
                interval: 200,
                duration: 3000,
            },
        });
        featureHighlight.load();
        G.featureHighlight = featureHighlight;
        G.featureHighlight.layer.setZIndex(102);
        // 图层管理器
        const layerManager: any = new G.common.LayerManager({
            map: this.getMap(),
        });
        layerManager.load();
        // 缓冲组件
        const bufferDraw: any = new G.interact.Buffer({
            map: this.getMap(),
            zIndex: 10,
            name: '缓冲区',
            close: {
                visible: true,
                style: {
                    type: 'PictureMarkerSymbol',
                    options: {
                        width: '41',
                        height: '41',
                        rotation: '0',
                        opacity: '1',
                        offsetX: 0,
                        offsetY: 0,
                        source: this.options.symbolConfig.icons.bufferClose,
                    },
                },
            },
        });
        bufferDraw.load();
        // 简单渲染组件
        const simpleRenderMgr: any = new G.render.SimpleRenderMgr({
            map: this.getMap(),
        });
        simpleRenderMgr.load();
        // 点数据坐标检查的构建器
        const PointGeometryBuilder = G.utils.GeometryBuilder.extend({
            check: (geometry: any) => {
                // 统一进行坐标检查 ，过滤为零的坐标
                const check = G.utils.CoordUtil.verify([geometry.x, geometry.y], 4326);
                if (check) {
                    if (parseFloat(geometry.x) === 0 || parseFloat(geometry.y) === 0) {
                        return false;
                    }
                    return true;
                } else {
                    return false;
                }
            },
        });

        const commandManager = new egis.gdm.CommandManager();
        const commandNotify = new egis.gdm.CommandNotify({
            manager: commandManager,
        });
        const components: any = {
            popupManager,
            featureLocate,
            featureHighlight,
            layerManager,
            simpleRenderMgr,
            bufferDraw,
            PointGeometryBuilder,
            commandManager,
            commandNotify,
        };
        if (this.getMap3D()) {
            const commandManager3D = new egis.gdm.CommandManager();
            const commandNotify3D = new egis.gdm.CommandNotify({
                manager: commandManager3D,
            });
            this.getMap().commandManager = commandManager;
            this.getMap3D().commandManager3D = commandManager3D;
            components.commandManager3D = commandManager3D;
            components.commandNotify3D = commandNotify3D;
        }
        this.components = components;
    }
    public getComponents() {
        return this.components;
    }

    public getComponent(id: any) {
        return this.components[id] || null;
    }
}
